import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { useLogout } from "@oysterhr/identity/MeContext"
import { Heading, OysterLogo, Text } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { useTransformZendeskUrl } from "~/hooks/useTransformZendeskUrl"

export const ErrorPage = ({ errorCode }: { errorCode: "401" | "404" | "410" | "429" | "500" }) => {
  const { t } = useTranslation("ErrorPage", { keyPrefix: errorCode })
  const supportUrl = useTransformZendeskUrl("https://support.oysterhr.com/hc/en-us/requests/new")
  const { isStaff } = useAccountAspect()
  const { handleLogout } = useLogout()

  return (
    <div className="absolute inset-0 flex h-screen w-full items-center justify-center bg-[url('/images/background.jpg')] bg-cover">
      <div className="flex h-full max-w-screen-container flex-col items-center">
        <div className="flex-grow"></div>
        <div>
          <img src="/images/mountain-icon.svg" role="presentation" alt="" />
        </div>
        <Heading
          className="text-[8.5rem] !font-normal !leading-[204px] text-primary-base"
          data-code={errorCode}
        >
          {t("errorCode")}
        </Heading>
        <div className="text-2xl">{t("errorMessage")} </div>
        <div className="flex flex-grow flex-col justify-between">
          <div className="mt-4 text-center">
            <Text className="text-2xl">
              <Trans
                t={t}
                i18nKey="suggestion"
                components={{
                  linkDashboard: <Link className="font-bold text-primary-base underline" to="/" />,
                  logout: (
                    <button
                      className="font-bold text-primary-base underline"
                      onClick={handleLogout}
                    />
                  ),
                  linkHelpCenter: (
                    <Link
                      className="underline"
                      to={isStaff ? "https://help.engineering.oysterhr.com/" : supportUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  ),
                }}
              />
            </Text>
          </div>
          <div className="mb-12 flex justify-center">
            <OysterLogo title="Oyster Logo" size="sm" />
          </div>
        </div>
      </div>
    </div>
  )
}
